import { type UserEntity, UserType } from "@/shared/types/user.entity";

/**
 * INTERNAL staff always; a member unless staff switched QR payments off for their organization. A backend
 * that predates the switch omits the field, and QR payments were open to everyone then.
 */
export function canPayBrebQr(user: UserEntity | null | undefined): boolean {
  if (!user) return false;
  return user.user_type === UserType.INTERNAL || user.organization?.breb_qr_payments_enabled !== false;
}

/**
 * Bold QRs stay refused unless staff turned them on for the organization: Bold's terminals settle a payment
 * from Coloca but never record the sale, so the payer ends up paying twice. Staff follow their own
 * organization.
 */
export function canPayBoldBrebQr(user: UserEntity | null | undefined): boolean {
  return user?.organization?.breb_qr_bold_payments_enabled === true;
}
